"use client";

import { motion } from "framer-motion";
import { Clock, ShieldCheck, Eye, Pause } from "lucide-react";

export default function AutopilotPhone() {
  return (
    <div className="relative w-[300px] max-w-full rounded-[40px] border-[10px] border-ink-950 bg-ink-950 shadow-2xl">
      <div className="absolute left-1/2 top-2 z-20 h-4 w-20 -translate-x-1/2 rounded-full bg-ink-950" />
      <div className="overflow-hidden rounded-[30px] bg-[#f6f6f6]">
        <div className="bg-[#f6f6f6] px-4 pt-9 pb-3 text-center">
          <p className="text-[12px] font-semibold text-ink-900">OneTapReply</p>
          <p className="text-[10px] text-ink-500">Autopilot · iMessage</p>
        </div>

        <div className="space-y-2 px-3 pb-6">
          <p className="sms-meta">Today 10:14 AM</p>

          <motion.div
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            className="flex justify-start"
          >
            <div className="sms-bubble-in" style={{ maxWidth: "88%" }}>
              <p className="text-[12px] font-semibold mb-1">Heads up 👀</p>
              <p className="text-[13px] leading-snug text-ink-700">
                3-star from <strong>Mike R.</strong> — Pine Street Café.
                Drafted a thoughtful reply.
              </p>
              <div className="mt-2.5 -mx-2 -mb-1 flex flex-col gap-px border-t border-black/10 pt-2">
                <button
                  type="button"
                  className="mx-2 mb-1 flex items-center justify-center gap-1.5 rounded-lg bg-brand-600 px-3 py-2 text-[12px] font-bold text-white"
                >
                  <Eye className="h-3.5 w-3.5" aria-hidden="true" />
                  See draft
                </button>
                <button
                  type="button"
                  className="mx-2 flex items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-[12px] font-semibold text-ink-700 hover:bg-black/5"
                >
                  <Pause className="h-3.5 w-3.5" aria-hidden="true" />
                  Pause autopilot
                </button>
              </div>
            </div>
          </motion.div>

          <p className="sms-meta">Today 10:14 AM · Auto-posted ✓</p>

          <motion.div
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="flex justify-start"
          >
            <div className="sms-bubble-in">
              <p className="text-[12px] font-semibold mb-1">5★ from Aisha B.</p>
              <p className="text-[13px] leading-snug text-ink-700">
                Auto-posted at 10:14 AM:
                <br />
                <em className="text-ink-600">
                  &ldquo;Thanks Aisha — see you on Sundays!&rdquo;
                </em>
              </p>
              <p className="mt-2 text-[10px] text-ink-500">
                <Clock className="mr-1 inline h-3 w-3" /> Live on Google · 12s
              </p>
            </div>
          </motion.div>

          <p className="sms-meta">Today 8:00 PM · Daily digest</p>

          <motion.div
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: 0.4 }}
            className="flex justify-start"
          >
            <div className="sms-bubble-in">
              <p className="text-[12px] font-semibold mb-1">Today, in numbers</p>
              <ul className="text-[12px] leading-relaxed text-ink-700">
                <li>4 reviews · 4 replies posted</li>
                <li>Avg response time: <strong>11s</strong></li>
                <li>1 paused for your review (Mike R.)</li>
              </ul>
              <p className="mt-2 text-[10px] text-ink-500">
                <ShieldCheck className="mr-1 inline h-3 w-3" /> Tap to review the paused one
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
